import { fetchSettingAwareness } from '../../module/services/fetchSettingAwareness';
import { fetchUpdateSettingAwareness } from '../../module/services/fetchUpdateSettingAwareness';
import { listSettingType, settingAwareness } from '../../module/types/UserSchema';
import { Fragment, useEffect, useState } from 'react';
import { TitleList } from '@app/shared/ui/WrapperList/TitleList';
import { Switcher } from '@app/shared/ui/ui-kit/Switcher';
import { Tag } from '@app/components/ui-kit/Tag';
import { listSetting } from './listSetting';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button, ButtonSize, ButtonThemes, TagTape, SkeletonLoading } from '@app/shared';
import { ModalWindow } from '@app/shared/ui/ModalWindow';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

import styles from './SettingAwarenessUser.module.scss';

export const SettingAwarenessUser = ({ title }) => {
  const [active, setActive] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [selected, setSelected] = useState<listSettingType>(null);
  const [fullListSetting, setFullListSetting] = useState<listSettingType[]>([]);
  const [list, setList] = useState<settingAwareness>(null);

  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    loadSettings();
  }, []);

  useEffect(() => {
    if (!list) {
      return;
    }

    const updatedNewData = listSetting.map(item => ({
      ...item,
      consent: list[item.currentConsent],
    }));

    setFullListSetting(updatedNewData);
  }, [list]);

  const loadSettings = async () => {
    setIsLoaded(true);

    const data = await fetchSettingAwareness();

    if (data) {
      setList(data);
      setError(false);
    } else {
      setError(true);
    }
    setIsLoaded(false);
  };

  const handleConsentUpdate = async (consentType, condition) => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return false;
    }

    try {
      const captchaTokenGoogle = await executeRecaptcha('submit');
      await fetchUpdateSettingAwareness({
        consents: { [consentType]: condition },
        captchaTokenGoogle,
      });
      return true;
    } catch (error) {
      setError(true);
      console.error('Ошибка обновления согласия:', error);
      return false;
    }
  };

  const updateConsent = (consentType, updatedValue) => {
    setList(prevList => ({
      ...prevList,
      [consentType]: updatedValue,
    }));

    setFullListSetting(prevFullList =>
      prevFullList.map(item => (item.currentConsent === consentType ? { ...item, consent: updatedValue } : item)),
    );
  };
  const handleSwitcherToggle = async cancellAgree => {
    ServiceEcommerce2.settingsToggle();
    if (cancellAgree.consent === 1) {
      setActive(true);
      setSelected(cancellAgree);
    } else {
      const currentAgreeValue = list[cancellAgree.currentConsent];
      const updatedValue = Number(!currentAgreeValue);
      const isSuccess = await handleConsentUpdate(cancellAgree.currentConsent, updatedValue);

      if (isSuccess) {
        updateConsent(cancellAgree.currentConsent, updatedValue);
      }
    }
  };

  const handleAppointAgree = async item => {
    const resultAppoint = item.consent;
    const condition = resultAppoint === null ? 1 : 0;

    ServiceEcommerce2.settingsToggle();

    const isSuccess = await handleConsentUpdate(item.currentConsent, condition);
    if (isSuccess) {
      updateConsent(item.currentConsent, condition);
    }
  };

  const handleConfirm = () => {
    if (selected) {
      ServiceEcommerce2.settingsToggle();
      handleAppointAgree(selected);
      setActive(false);
    }
  };

  if (isLoaded) {
    return <SettingAwarenessUser.Skeleton />;
  }

  return (
    <Fragment>
      {active && (
        <ModalWindow
          active={active}
          setActive={setActive}
          value={selected.title}
          text={selected.descr}
          info={selected.info}
          image={selected.img}
          btnAction={handleConfirm}
          className={styles.Modal}
          buttonTextOne="Отмена"
          buttonTextTwo="Отказаться"
        />
      )}
      {error && (
        <ModalWindow
          value="Ошибка"
          text="Не удалось сохранить данные. Обратитесь в службу поддержки."
          buttonTextTwo="Закрыть"
          active={active}
          setActive={() => setError(false)}
          btnAction={() => setError(false)}
          className={styles.ModalError}
        />
      )}
      <div className={styles.WrapperNotification}>
        <TitleList title={title} />
        <Tag tag={TagTape.H3}>Рассылки и звонки</Tag>
        <span>Как вы хотите получать персональные предложения и новости?</span>
        <div className={styles.Container}>
          {fullListSetting.map(item => {
            return (
              <div key={item.name} className={styles.Content}>
                <span className={styles.Title}>{item.name}</span>
                <div>
                  {item.consent == null ? (
                    <Button
                      className={styles.Agree}
                      themes={ButtonThemes.DarkViolet}
                      size={ButtonSize.S}
                      onClick={() => {
                        handleAppointAgree(item);
                      }}
                    >
                      Выбрать
                    </Button>
                  ) : (
                    <Switcher
                      color="green"
                      active={Boolean(item.consent)}
                      className={styles.Switcher}
                      onChange={() => {
                        handleSwitcherToggle(item);
                        setSelected(item);
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

SettingAwarenessUser.Skeleton = function Skeleton() {
  return (
    <div className={styles.Wrapper}>
      <SkeletonLoading width={'100%'} height={'83px'} />
      <SkeletonLoading width={'100%'} height={'83px'} />
      <SkeletonLoading width={'100%'} height={'83px'} />
      <SkeletonLoading width={'100%'} height={'83px'} />
      <SkeletonLoading width={'100%'} height={'83px'} />
    </div>
  );
};
